import { Chip, FormLabel } from "@mui/material";
import Autocomplete, {
  AutocompleteChangeReason,
} from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { useTranslation } from "react-i18next";

interface TagTextFieldProps {
  fieldId: string;
  onChange: (fieldId: string, value: string) => void;
  initialValue?: string[];
  placeholder?: string;
  required?: boolean;
}

const TagTextField = (props: TagTextFieldProps) => {
  const { t } = useTranslation();
  const { fieldId, placeholder, initialValue, required, onChange } = props;

  const handleChange = (
    event: React.SyntheticEvent,
    value: string[],
    reason: AutocompleteChangeReason,
  ) => {
    if (reason === "createOption" || reason === "removeOption")
      onChange(fieldId, value.join(","));
  };

  return (
    <Autocomplete
      id={"auto-complete-tag-text-field-" + fieldId}
      clearIcon={false}
      options={[]}
      freeSolo
      multiple
      value={initialValue}
      onChange={handleChange}
      renderTags={(value, props) => {
        return value.map((option, index) => {
          const { key, className, disabled, tabIndex, onDelete } = props({
            index,
          });

          return (
            <Chip
              key={key}
              className={className}
              disabled={disabled}
              tabIndex={tabIndex}
              onDelete={onDelete}
              label={option}
            />
          );
        });
      }}
      renderInput={(params) => (
        <>
          <FormLabel required={required}>{t(fieldId)}</FormLabel>
          <TextField
            {...params}
            className="input-element"
            id={fieldId}
            variant="outlined"
            placeholder={placeholder || t("clickEnterToAdd")}
            required={required}
          />
        </>
      )}
    />
  );
};

export default TagTextField;
